export default __webpack_public_path__ + "static/media/gh.e2793fb1.svg";